/**
 * [FIX-2] Keyboard/screen-reader retrofit for the Globo Mega Menu app.
 *
 * Globo rewrites ul.top-navigation into .gm-menu markup at runtime: submenus
 * open on :hover only, with no aria-expanded and no keyboard path. Its DOM is
 * app-generated, so instead of editing it server-side this script enhances it
 * after it initializes:
 *   - each item with a submenu gets a real <button> toggle (aria-expanded,
 *     aria-controls) placed after its link, so Enter/Space opens the panel
 *     while the link itself still navigates
 *   - Escape closes the open panel and returns focus to its toggle
 *   - clicking/tabbing outside closes any open panel
 *   - the theme-side hamburger (.menu-icon a) mirrors open state into
 *     aria-expanded
 * Visibility is forced via the .vb-kbd-open class (rules in vulcan-ux.css),
 * so hover behavior for mouse users is untouched.
 */
(function () {
  'use strict';

  var TOGGLE_CLASS = 'vb-submenu-toggle';
  var OPEN_CLASS = 'vb-kbd-open';

  function closeAll(except) {
    document.querySelectorAll('.gm-item.' + OPEN_CLASS).forEach(function (li) {
      if (li === except) return;
      li.classList.remove(OPEN_CLASS);
      var btn = li.querySelector('.' + TOGGLE_CLASS);
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
  }

  function enhanceItem(li, index) {
    var target = li.querySelector(':scope > a.gm-target') || li.querySelector('a.gm-target');
    var submenu = li.querySelector(':scope > .gm-submenu');
    if (!target || !submenu || li.querySelector('.' + TOGGLE_CLASS)) return;

    if (!submenu.id) submenu.id = 'vb-gm-sub-' + index;

    var label = (target.textContent || 'menu').replace(/\s+/g, ' ').trim();
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = TOGGLE_CLASS;
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-controls', submenu.id);
    btn.setAttribute('aria-label', 'Open ' + label + ' submenu');
    btn.innerHTML = '<span aria-hidden="true">▾</span>';
    target.insertAdjacentElement('afterend', btn);

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var open = li.classList.toggle(OPEN_CLASS);
      btn.setAttribute('aria-expanded', String(open));
      if (open) closeAll(li);
    });

    li.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && li.classList.contains(OPEN_CLASS)) {
        li.classList.remove(OPEN_CLASS);
        btn.setAttribute('aria-expanded', 'false');
        btn.focus();
        e.stopPropagation();
      }
    });
  }

  function enhanceMenus() {
    var menus = document.querySelectorAll('ul.gm-menu:not([data-vb-a11y])');
    if (!menus.length) return false;
    menus.forEach(function (menu) {
      menu.setAttribute('data-vb-a11y', 'true');
      menu.querySelectorAll('.gm-item.gm-has-submenu').forEach(enhanceItem);
    });
    return true;
  }

  function init() {
    // Globo initializes asynchronously; enhance now if it's there, otherwise
    // watch until its markup lands (and re-run if it re-renders).
    enhanceMenus();
    if (window.MutationObserver) {
      new MutationObserver(function () { enhanceMenus(); })
        .observe(document.body, { childList: true, subtree: true });
    }

    document.addEventListener('click', function (e) {
      if (!e.target.closest('.gm-item.' + OPEN_CLASS)) closeAll();
    });
    document.addEventListener('focusin', function (e) {
      if (!e.target.closest('.gm-item.' + OPEN_CLASS)) closeAll();
    });

    // Theme-side hamburger: mirror the mobile nav's open state.
    document.querySelectorAll('.menu-icon a').forEach(function (burger) {
      burger.addEventListener('click', function () {
        setTimeout(function () {
          var open = document.body.classList.contains('mobile-nav-open') ||
            !!document.querySelector('.mobile-nav.active, .mobile-nav.open, .mobile-nav[style*="left: 0"]');
          burger.setAttribute('aria-expanded', String(open));
        }, 50);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
